export const CHARACTERISTIC_UNITS = `
query CharacteristicUnits { 
\tcharacteristicUnits { 
  \tid
    name
  }
}
`
